module.exports = __webpack_public_path__ + "static/media/underline.a0a90400.svg";